import { Injectable } from '@angular/core';
import { BaseApiClient } from './base-api.client';
import { environment } from 'src/environments';

@Injectable({ providedIn: 'root' })
export class CountryApiClient extends BaseApiClient {
  override basePath: string = `${environment.apiBaseUrl}country`;
}
